"use client"

import { useState, useEffect, useCallback } from "react"
import { useAuth } from "./use-auth"
import { useTranslations } from "next-intl"


export function useSystemAccess() {
  const tUi = useTranslations("Feedback.UseSystemAccess")

  const { fetchWithAuth, isAuthenticated } = useAuth()
  const [systemAccess, setSystemAccess] = useState(true)
  const [isLoading, setIsLoading] = useState(true)

  // Load system access status
  const loadSystemAccess = useCallback(async () => {
    try {
      const response = await fetch("/api/system/access", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })

      if (response.ok) {
        const data = await response.json()
        setSystemAccess(data.enabled)
      } else {
        console.error("Failed to load system access status")
        // Default to enabled if we can't fetch the status
        setSystemAccess(true)
      }
    } catch (error) {
      console.error("Error loading system access status:", error)
      // Default to enabled if there's an error
      setSystemAccess(true)
    } finally {
      setIsLoading(false)
    }
  }, [])

  useEffect(() => {
    loadSystemAccess()
  }, [loadSystemAccess])

  const toggleSystemAccess = async () => {
    if (!isAuthenticated) {
      throw new Error(tUi("userNotAuthenticated"))
    }

    try {
      const response = await fetchWithAuth("/api/system/access", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ enabled: !systemAccess }),
      })

      if (response.ok) {
        const data = await response.json()
        setSystemAccess(data.enabled)
      } else {
        throw new Error(tUi("failedToToggleSystemAccess"))
      }
    } catch (error) {
      console.error("Error toggling system access:", error)
      throw error
    }
  }

  return {
    systemAccess,
    isLoading,
    toggleSystemAccess,
    refreshSystemAccess: loadSystemAccess,
  }
}
